import { formatHours } from "./timeUtils";
import { FormatType } from "./types";

describe("timeUtis.ts", () => {
  it.each([
    ["1:30", "1:30"],
    ["1:30", "01:30", true],
    ["1.5", "1:30"],
    ["1.05", "1:03"],
    ["5,5", "5:30"],
    ["5.5", "5:30"],
    ["5:30", "5:30"],
    [",5", "0:30"],
    [".5", "0:30"],
    ["", ""],
    [":", "0:00"],
    ["1:", "1:00"],
    ["1:", "01:00", true],
    [":05", "00:05", true],
    [",05", "00:03", true],
    [0.5, "00:30", true],
    [1.5, "01:30", true],
    [1.5, "1:30", false],
    ["0:3", "0:30", false],
    ["555:35", "555:35", false],
    ["555", "555:00", false],
    [555.5, "555:30", false],
    ["5:00", "5", false, true],
    ["05:00", "05", true, true],
    ["12:00", "12", false, true],
    ["12:30", "12:30", false, true],
    [5, "5:00", false, false],
    [5, "5", false, true],
    [0, "0:00", false, false],
    [0, "0", false, true],
    [5, "05", true, true],
    ["5:00", "05", true, true],
    ["05:00", "5", false, true],
    [1500, "1.5K", false, false, "short" as FormatType],
    [1000, "1K", false, false, "short" as FormatType],
    ["999.50", "999:30", false, false, "short" as FormatType],
    [1500.25, "1.5K", false, false, "short" as FormatType],
  ])(
    "should formatTime",
    (
      value,
      expected,
      leadingZero = false,
      trimZeroMinutes = false,
      format = "long"
    ) =>
      expect(formatHours(value, leadingZero, trimZeroMinutes, format)).toEqual(
        expected
      )
  );
});
